import { createContext, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setClass, setSubject, setteacherId } from '../features/teachersubject/teacherSubSlice';

const ClassSubjectContext = createContext();

export const ClassSubjectProvider = ({ children }) => {
  const { selectedClass, selectedSubject, teacherId } = useSelector(state => state.teacherSub);
  const dispatch = useDispatch();

  const setSelectedClass = (className) => dispatch(setClass(className));
  const setSelectedSubject = (subject) => dispatch(setSubject(subject));
  const setTeacherId = (id) => dispatch(setteacherId(id));

  return (
    <ClassSubjectContext.Provider value={{ 
      selectedClass, 
      setSelectedClass, 
      selectedSubject, 
      setSelectedSubject, 
      teacherId, 
      setTeacherId 
    }}>
      {children}
    </ClassSubjectContext.Provider>
  );
};

export const useClassSubject = () => {
  const context = useContext(ClassSubjectContext);
  if (!context) {
    throw new Error('useClassSubject must be used within a ClassSubjectProvider');
  }
  return context;
};

